import SmallLevel1 from "../../assets/images/level/medal_11x.png";
import SmallLevel2 from "../../assets/images/level/medal_21x.png";
import SmallLevel3 from "../../assets/images/level/medal_31x.png";
import SmallLevel4 from "../../assets/images/level/medal_41x.png";
import SmallLevel5 from "../../assets/images/level/medal_51x.png";

import BigLevel1 from "../../assets/images/level/medal_12x.png";
import BigLevel2 from "../../assets/images/level/medal_22x.png";
import BigLevel3 from "../../assets/images/level/medal_32x.png";
import BigLevel4 from "../../assets/images/level/medal_42x.png";
import BigLevel5 from "../../assets/images/level/medal_52x.png";

export const bigLevelImagesArray = [BigLevel1, BigLevel1, BigLevel2, BigLevel3, BigLevel4, BigLevel5];

export const smallLevelImagesArray = [SmallLevel1, SmallLevel1, SmallLevel2, SmallLevel3, SmallLevel4, SmallLevel5];
